export interface PaymentMethod {
  id: string;
  description: string;
  imageUrl: string;
  isOfflinePaymentMethod: boolean;
}

export enum PAYMENT_STATUS {
  NOT_STARTED = 'not_started',
  NEW = 'new',
  COMPLETED = 'completed',
  FAILED = 'failed',
  DETACHED = 'detached',
}

export interface PaymentStatus {
  status: PAYMENT_STATUS;
  retryAllowed: boolean;
}

export interface CheckoutUrl {
  checkoutUrl: string;
}
